import LegalLayout from "./_LegalLayout";

export default function Impressum() {
    return (
        <LegalLayout title="Impressum" subtitle="Informazioni legali ai sensi della normativa svizzera">
            <h2>Titolare del sito</h2>
            <p>
                <strong>7MED GROUP</strong><br />
                Via Luigi Lavizzari 2<br />
                6850 Mendrisio · Svizzera
            </p>

            <h2>Contatti</h2>
            <p>
                Telefono: <a href="tel:+41912615199">+41 91 261 51 99</a><br />
                Email: <a href="mailto:backoffice@7med.ch">backoffice@7med.ch</a><br />
                Web: <a href="https://7med.ch">www.7med.ch</a>
            </p>

            <h2>Sedi operative</h2>
            <ul>
                <li>Via Luigi Lavizzari 2, 6850 Mendrisio (c/o Scuola Guida DueGi)</li>
                <li>Via Cantonale 3, 6942 Savosa (c/o Scuola Guida DueGi)</li>
                <li>Via San Gottardo 22, 6500 Bellinzona</li>
                <li>Via ai Saleggi 5, 6600 Locarno (c/o Scuola Guida Tre)</li>
            </ul>

            <h2>Certificazioni</h2>
            <ul>
                <li>Centro di formazione certificato SRC (Swiss Resuscitation Council)</li>
                <li>Conforme alla legge sul lavoro OLL3 Art. 36</li>
                <li>Corsi certificati EduQua</li>
            </ul>

            <h2>Esclusione di responsabilità</h2>
            <p>I contenuti del sito 7med.ch sono redatti con la massima cura. 7MED GROUP non garantisce tuttavia l'esattezza, l'attualità, la correttezza, la completezza o la qualità delle informazioni fornite. Pretese di responsabilità nei confronti di 7MED GROUP per danni materiali o immateriali derivanti dall'accesso o dall'utilizzo delle informazioni pubblicate sono pertanto escluse.</p>

            <h2>Riferimenti e link</h2>
            <p>I riferimenti e i link a siti web di terzi non rientrano nel nostro campo di responsabilità. Si declina ogni responsabilità per tali siti web.</p>

            <h2>Diritto d'autore</h2>
            <p>I diritti d'autore e tutti gli altri diritti dei contenuti, immagini, foto e file presenti su questo sito appartengono esclusivamente a 7MED GROUP o ai legittimi titolari indicati. La riproduzione totale o parziale richiede il consenso scritto dei detentori dei diritti.</p>
        </LegalLayout>
    );
}
